export default "__VITE_ASSET__CzGpX$Ko__"